export default __webpack_public_path__ + "9d368e0c21ceb0998dd0264cb7b45eea.png";